import { render, staticRenderFns } from "./PlayerSelectCard.vue?vue&type=template&id=79dbd615&scoped=true&"
import script from "./PlayerSelectCard.vue?vue&type=script&lang=js&"
export * from "./PlayerSelectCard.vue?vue&type=script&lang=js&"
import style0 from "./PlayerSelectCard.vue?vue&type=style&index=0&id=79dbd615&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dbd615",
  null
  
)

export default component.exports